import { Link } from "react-router-dom";
import { PhoneCall, MessageSquare, MapPin, Clock, ShieldCheck } from "lucide-react";
import { CLINIC, SERVICES } from "@/data/content";

const Footer = () => (
  <footer className="bg-slate-950 text-slate-300" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 grid gap-12 md:grid-cols-2 lg:grid-cols-4">
      <div>
        <p className="font-serif text-2xl font-semibold text-white">Delhi STD Clinic</p>
        <p className="text-xs tracking-[0.22em] uppercase text-emerald-300/80 mt-1 font-semibold">
          by Dr. Ankur Lal
        </p>
        <p className="mt-5 text-sm leading-relaxed text-slate-400">
          Confidential STD, STI, HIV and sexual-health care in Delhi — online and in
          clinic. {CLINIC.credentialLine}. {CLINIC.medal}.
        </p>
        <p className="mt-5 inline-flex items-center gap-2 text-xs text-emerald-300/90 border border-emerald-800/70 rounded-full px-4 py-1.5">
          <ShieldCheck className="w-3.5 h-3.5" /> Private • Confidential • Judgment-Free
        </p>
      </div>

      <div>
        <p className="text-xs tracking-[0.25em] uppercase text-slate-500 font-semibold mb-4">
          Treatments
        </p>
        <ul className="space-y-2.5 text-sm">
          <li>
            <Link to="/hiv-pep-delhi" data-testid="footer-link-hiv-pep" className="hover:text-amber-300 transition-colors">
              HIV PEP (Urgent)
            </Link>
          </li>
          {SERVICES.map((s) => (
            <li key={s.slug}>
              <Link
                to={`/services/${s.slug}`}
                data-testid={`footer-link-${s.slug}`}
                className="hover:text-amber-300 transition-colors"
              >
                {s.name}
              </Link>
            </li>
          ))}
        </ul>
      </div>

      <div>
        <p className="text-xs tracking-[0.25em] uppercase text-slate-500 font-semibold mb-4">
          Clinic
        </p>
        <ul className="space-y-2.5 text-sm">
          <li><Link to="/about-dr-ankur-lal" data-testid="footer-link-about" className="hover:text-amber-300 transition-colors">About Dr. Ankur Lal</Link></li>
          <li><Link to="/online-consultation" data-testid="footer-link-online" className="hover:text-amber-300 transition-colors">Online Consultation</Link></li>
          <li><Link to="/std-symptoms" data-testid="footer-link-symptoms" className="hover:text-amber-300 transition-colors">STD/STI Symptoms</Link></li>
          <li><Link to="/std-hiv-testing" data-testid="footer-link-testing" className="hover:text-amber-300 transition-colors">STD & HIV Testing</Link></li>
          <li><Link to="/privacy-confidentiality" data-testid="footer-link-privacy" className="hover:text-amber-300 transition-colors">Privacy & Confidentiality</Link></li>
          <li><Link to="/faq" data-testid="footer-link-faq" className="hover:text-amber-300 transition-colors">FAQ</Link></li>
          <li><Link to="/booking" data-testid="footer-link-booking" className="hover:text-amber-300 transition-colors">Book Appointment</Link></li>
          <li><Link to="/privacy-policy" data-testid="footer-link-legal" className="hover:text-amber-300 transition-colors">Privacy Policy & Legal</Link></li>
        </ul>
      </div>

      <div>
        <p className="text-xs tracking-[0.25em] uppercase text-slate-500 font-semibold mb-4">
          Contact
        </p>
        <ul className="space-y-3.5 text-sm">
          <li>
            <a href={`tel:${CLINIC.phoneRaw}`} data-testid="footer-phone" className="flex items-start gap-3 hover:text-amber-300 transition-colors">
              <PhoneCall className="w-4 h-4 mt-0.5 shrink-0 text-emerald-400" />
              {CLINIC.phoneDisplay}
            </a>
          </li>
          <li>
            <a href={CLINIC.whatsapp} target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp" className="flex items-start gap-3 hover:text-amber-300 transition-colors">
              <MessageSquare className="w-4 h-4 mt-0.5 shrink-0 text-emerald-400" />
              WhatsApp the clinic
            </a>
          </li>
          <li className="flex items-start gap-3 text-slate-400">
            <MapPin className="w-4 h-4 mt-0.5 shrink-0 text-emerald-400" />
            {CLINIC.address}
          </li>
          <li className="flex items-start gap-3 text-slate-400">
            <Clock className="w-4 h-4 mt-0.5 shrink-0 text-emerald-400" />
            {CLINIC.timings}
          </li>
        </ul>
      </div>
    </div>

    <div className="border-t border-white/8">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-slate-500">
        <p>© {new Date().getFullYear()} Delhi STD Clinic — Dr. Ankur Lal. All rights reserved.</p>
        <p className="text-center sm:text-right max-w-xl">
          The information on this website is for general education and is not a
          substitute for personalized medical advice, diagnosis or treatment.
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
